import { createAction } from 'redux-actions';
export const createPollRequest = createAction('POLL.CREATE_REQUEST', (payload)=>payload);
export const createPollSuccess = createAction('POLL.CREATE_SUCCESS', (payload)=>payload);
export const updatePollRequest = createAction('POLL.UPDATE_REQUEST', (payload)=>payload);
export const updatePollSuccess = createAction('POLL.UPDATE_SUCCESS', (payload)=>payload);
export const requestFailure = createAction('POLL.REQUEST_FAILURE', ()=>({}));
